import { render, staticRenderFns } from "./ThaiTranslation.vue?vue&type=template&id=501cc8b7"
import script from "./ThaiTranslation.vue?vue&type=script&lang=js"
export * from "./ThaiTranslation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports